import { Component, OnDestroy, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ContractsCommonService } from '../../service/contract-creation/contracts-common.service';
import { Subscription } from 'rxjs';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-container-type-info',
  templateUrl: './container-type-info.component.html',
  styleUrls: ['./container-type-info.component.scss'],
  standalone :false,
})
export class ContainerTypeInfoComponent implements OnDestroy {
  @ViewChild('containerTable') containerTable!: Table;
  
  visible: boolean = false;
  containerDetails: any;
  searchTerm: string = '';
  private subscription: Subscription = new Subscription();
  constructor(private contractCommonService: ContractsCommonService, private messageService: MessageService) {
    const cachedContainerTypes = this.contractCommonService.getContainerTypesSync();
    if (cachedContainerTypes) {
      this.containerDetails = cachedContainerTypes;
    } else {
      console.log('Fetching container type details...');
      this.subscription.add(
        this.contractCommonService.containerTypes$.subscribe((response: any) => {
          if (response) {
            this.containerDetails = response;
          }
        })
      );

      this.subscription.add(
        this.contractCommonService.getAllContainerTypes().subscribe({
          next: (response: any) => {
            if (response && response.data) {
              this.containerDetails = response.data;
            }
          },
          error: (error) => {
            console.error('Error fetching container types:', error);
          }
        })
      );
    }
  }

  copyToClipboard(value: string): void {
    navigator.clipboard.writeText(value).then(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Copied to clipboard: ' + value
      });
    }).catch(err => {
      console.error('Error copying text: ', err);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to copy text.'
      });
    });
  }

  downloadContainerDetails(): void {
    const csvData = this.convertToCSV(this.containerDetails);
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'container_details.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  private convertToCSV(data: any[]): string {
    if (!data || !data.length) {
      return '';
    }
    const headers = ['Container Type Description', 'Container Type Code'];
    const rows = data.map(row => [
      this.escapeCSVValue(row.containerTypeDesc),
      this.escapeCSVValue(row.containerTypeCode)
    ]);
    const csvRows = rows.map(row => row.join(','));
    return [headers.join(','), ...csvRows].join('\n');
  }

  private escapeCSVValue(value: string): string {
    if (value === null || value === undefined) {
      return '';
    }
    if (value.includes(',') || value.includes('"') || value.includes('\n')) {
      return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
  }

  resetFilters(): void {
    this.searchTerm = '';
    if (this.containerTable) {
      this.containerTable.clear();
      this.containerTable.filterGlobal(this.searchTerm, 'contains');
      this.containerTable.reset();
      this.containerTable.rows = 10;
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}